import { z } from 'zod'

export const ResetPasswordPayload = z.object({
    email: z.string().email(),
})
